import React from 'react';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import Label from '../../FormElements/Label';
import TextInput from '../../FormElements/TextInput';
import MonthYearInput from '../../FormElements/MonthYearInput';
import Select2DropdownList from '../../FormElements/Select2DropdownList';
import Switch from '../../FormElements/Switch';
import FormSection from '../../FormElements/FormSection';
import FormSubmit from '../../FormElements/FormSubmit';
import LoaderOverlay from '../../LoaderOverlay/LoaderOverlay';

export default class EditUserCustomDataForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			customHcnTribalId: '',
			customHcnSchoolDistrict: '',
			gradMonth: '',
			gradYear: '',
			isIepRequired: '',
			globalErrors: [],
			fieldErrors: {}
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onSetFieldError = this.onSetFieldError.bind(this);
	}

	componentDidMount() {
		this.loadData();
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.iam_get_user_custom_endpoint !==
			this.props.iam_get_user_custom_endpoint
		) {
			this.loadData();
		}
	}

	render() {
		return (
			<div className="FormElements">
				<form onSubmit={this.onSubmit}>
					<FormSection>
						<GlobalErrorsBox globalErrors={this.state.globalErrors} />
						<div className="my-3">
							<Label>{I18n.t('admin.user_profile.tribal_id')}</Label>
							<TextInput
								style={this.styleTextInputOnError('customHcnTribalId')}
								placeholder=""
								name="customHcnTribalId"
								value={this.state.customHcnTribalId}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						<div className="my-3">
							<Label>{I18n.t('admin.user_profile.district')}</Label>
							<Select2DropdownList
								name="customHcnSchoolDistrict"
								placeholder="Select a district"
								data={
									this.props.userData &&
									this.props.userData.customData &&
									this.props.userData.customData.fields[1].options
								}
								isMulti={false}
								value={
									this.props.userData &&
									this.props.userData.customData &&
									this.props.userData.customData.fields[1].value &&
									this.props.userData.customData.fields[1].value.asObject &&
									this.props.userData.customData.fields[1].value.asObject
										.customHcnSchoolDistrict &&
									this.props.userData.customData.fields[1].value.asObject
										.customHcnSchoolDistrict.optionValue
								}
								style={{ width: '100%', display: 'block' }}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						<div className="my-3">
							<Label>
								{I18n.t('admin.user_profile.high_school_graduation_date')}
							</Label>
							<MonthYearInput
								style={this.styleTextInputOnError(
									'customHcnHighSchoolGraduationDate'
								)}
								name="customHcnHighSchoolGraduationDate"
								month={this.state.gradMonth}
								year={this.state.gradYear}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						<div className="my-3">
							<Label>{I18n.t('admin.user_profile.is_iep_required')}</Label>
							<Switch
								isOn={this.state.isIepRequired}
								handleToggle={() => {
									this.onChange({
										target: {
											name: 'isIepRequired',
											value: !this.state.isIepRequired
										}
									});
								}}
								id="iep-required"
							/>
						</div>
					</FormSection>
					<FormSubmit
						text={I18n.t(
							'admin.user_profile.update_user_profile_submit_button'
						)}
					/>
				</form>
				{this.state.loading ? <LoaderOverlay /> : null}
			</div>
		);
	}

	styleTextInputOnError(fieldName) {
		if (this.state.fieldErrors) {
			if (fieldName in this.state.fieldErrors) {
				return { border: '1px solid #ff3d60', borderRadius: '5px' };
			}
		}
	}

	onSetFieldError(errorsArray, error) {
		if (errorsArray.includes(error)) {
			return 'Error';
		}
	}

	onChange(e) {
		if (typeof e === 'object' && e !== null && e.month !== undefined) {
			this.setState({
				gradMonth: e.month,
				gradYear: e.year
			});
		} else {
			// It's a single input field
			this.setState({
				[e.target.name]: e.target.value
			});
		}
	}

	onSubmit(e) {
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			loading: true
		});

		$.ajax({
			type: 'POST',
			url: this.props.iam_update_user_profile_endpoint,
			data: {
				user_id: this.props.userId,
				presentationId: this.props.userData.customData.presentationId,
				customHcnTribalId: this.state.customHcnTribalId,
				customHcnSchoolDistrict: this.state.customHcnSchoolDistrict,
				gradMonth: this.state.gradMonth,
				gradYear: this.state.gradYear,
				isIepRequired: this.state.isIepRequired
			},
			dataType: 'json'
		}).done((data) => {
			if (data.status === 'success') {
				this.setState({
					loading: false
				});
				this.props.updateCustomData(data.data);
				this.props.onHidePopup();
				this.props.onShowSuccessCardPopup();
			} else if (data.status == 'session_expired') {
				this.props.onHidePopup();
				this.props.onShowTimeoutCardPopup(
					setTimeout(() => {
						window.location.href = `/admin/${this.props.public_id}/signin`;
					}, 5000)
				);
			} else {
				this.setState({
					loading: false,
					globalErrors: data.data.global,
					fieldErrors: data.data.fields
				});
			}
		});
	}

	loadData() {
		this.setState({ loading: true });
		$.ajax({
			type: 'GET',
			url: this.props.iam_get_user_custom_endpoint,
			data: {
				user_id: this.props.userData.summaryData.id
			}
		}).done((payload) => {
			const result = payload;
			this.setState({
				loading: false,
				customHcnTribalId:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[0].value &&
					result.data.fields[0].value.asString,
				customHcnSchoolDistrict:
					result.data &&
					result.data &&
					result.data.fields[1].value &&
					result.data.fields[1].value.asObject &&
					result.data.fields[1].value.asObject.customHcnSchoolDistrict &&
					result.data.fields[1].value.asObject.customHcnSchoolDistrict
						.optionValue,
				gradMonth:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[2].value &&
					result.data.fields[2].value.asString &&
					result.data.fields[2].value.asObject.customHcnHighSchoolGraduationDate
						.month,
				gradYear:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[2].value &&
					result.data.fields[2].value.asString &&
					result.data.fields[2].value.asObject.customHcnHighSchoolGraduationDate
						.year,
				isIepRequired:
					(result &&
						result.data.fields &&
						result.data.fields[3].value &&
						result.data.fields[3].value.asObject &&
						result.data.fields[3].value.asObject.customHcnIep &&
						result.data.fields[3].value.asObject.customHcnIep.booleanValue) ||
					false
			});
		});
	}
}
